module.exports = __webpack_public_path__ + "static/media/Rating.72989ad7.svg";